import palette from '../theme/palette';
import colors from '../theme/colors';

const styleOverrides = {
  root: {
    padding: '4px',
    margin: '-4px',
    color: colors.transparentGray[400],
    ['&.Mui-disabled']: {
      color: colors.transparentGray[400],
      opacity: 0.4,
    },
    ['&.Mui-checked, &.MuiCheckbox-indeterminate']: {
      color: palette.primary.main,
    },
  },
  colorInternal: {
    ['&.Mui-checked, &.MuiCheckbox-indeterminate, &.Mui-disabled']: {
      color: palette.internal.main,
    },
  },
  colorSuccess: {
    color: palette.success.main,
    ['&.Mui-checked, &.MuiCheckbox-indeterminate, &.Mui-disabled']: {
      color: palette.success.main,
    },
  },
};

export default styleOverrides;
